<pf-dropdown [hideArrow]="true">
    <div slot="button">
        <a class="nav-link" (click)="closeDropdownmain()">
            <i class="far fa-bell"></i>
            <span class="badge badge-warning navbar-badge">{{
                notificationCount
            }}</span>
        </a>
    </div>
    <div slot="menu" *ngIf="visible" class="notifications-dropdown">
        <div class="notifications-container">
            <!-- No Notifications Message -->
            <div *ngIf="notifications.length === 0" class="no-notifications">
                <div class="no-notifications-icon">
                    <i class="far fa-bell-slash"></i>
                </div>
                <h4 class="no-notifications-title">No Notifications</h4>
                <p class="no-notifications-message">
                    You're all caught up! No new notifications at the moment.
                </p>
            </div>

            <!-- Notification Items -->
            <div
                *ngFor="let notification of notifications"
                class="notification-card"
                (click)="closeDropdown()"
            >
                <!-- Icon -->
                <div
                    class="notification-icon"
                    [ngClass]="
                        getIconClass(getNotificationTypeFromTitle(notification))
                    "
                >
                    <img
                        [src]="
                            getNotificationIcon(
                                getNotificationTypeFromTitle(notification)
                            )
                        "
                        [alt]="
                            getNotificationTypeFromTitle(notification) + ' icon'
                        "
                        class="notification-svg-icon"
                    />
                </div>

                <!-- Content -->
                <div class="notification-content">
                    <!-- Header with title and priority badge -->
                    <div class="notification-header">
                        <h4 class="notification-title">
                            {{ getNotificationTitle(notification) }}
                        </h4>
                        <span
                            class="priority-badge"
                            [ngClass]="getPriorityClass(notification.priority)"
                        >
                            {{ notification.priority }}
                        </span>
                    </div>

                    <!-- Message -->
                    <p class="notification-message">
                        {{ getProcessedMessage(notification) }}
                    </p>

                    <!-- Time -->
                    <span class="notification-time">{{
                        calculateTimeAgo(notification.dateTime)
                    }}</span>
                </div>
            </div>
        </div>
    </div>
</pf-dropdown>
